import React from 'react';
import PropTypes from 'prop-types';
import { XS_MOBILE, SM_MOBILE, MD_TABLET } from "../../../../constants/textConstants";
import { connect } from "react-redux";
import { Card, LinkList, Icon, Typography } from '../../index';
import './card_link_list.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const CardLinkList = connect(mapStateToProps)(({
    body,
    cardIcon = '',
    className = '',
    disabled = false,
    title,
    list,
    titleStyle,
    bodyStyle,
    screenBreakPoint
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const iconColor = cardIcon?.color ? cardIcon?.color : "";
    const bodyColor = disabled ? "$color-secondary-a4" : "";
    const titleColor = disabled ? "$color-secondary-a4" : "$color-primary-a3";
    const bodyType = bodyStyle?.type ? bodyStyle?.type : "body-01";
    const titleType = titleStyle?.type ? titleStyle?.type : isMobile ? "body-03" : "heading-04";
    const titleBold = titleStyle?.bold !== undefined ? titleStyle?.bold : isMobile ? true : false;

    const cardLinkListClasses = [
        `mybswh-card-link-list`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <Card className={cardLinkListClasses}>
            <div className="mybswh-card-link-list__intro">
                <div className="mybswh-card-link-list__icon">
                    <Icon
                        color={iconColor}
                        disabled={disabled}
                        name={cardIcon?.name || 'schedule'}
                        set={cardIcon?.set || 'brand'}
                    />
                </div>
                <div className="mybswh-card-link-list__intro-text">
                    <Typography type={titleType} color={titleColor} tag="div" bold={titleBold}>{title}</Typography>
                    <Typography type={bodyType} color={bodyColor} tag="div">{body}</Typography>
                </div>
            </div>
            <div className="mybswh-card-link-list__links">
                <LinkList
                    list={list}
                />
            </div>
        </Card>
    )
});


CardLinkList.propTypes = {
    //Description text that shows beneath title
    body: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    //Customize color, name or icon set
    cardIcon: PropTypes.object,
    //Custom classname for Card
    className: PropTypes.string,
    //Disable top section of Card
    disabled: PropTypes.bool,
    // Title text
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    // List items to show in link list
    list: PropTypes.array,
    // Customize title type, color or bold style
    titleStyle: PropTypes.object,
    // Customize body type or color
    bodyStyle: PropTypes.object,
}